import { Link } from 'react-router-dom';
import { Linkedin, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative z-10 bg-slate-900 border-t border-border/30 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-2">
            <div className="flex items-center gap-4 mb-4">
              <img
                src="/assets/r-dale-brunet-logo.jpg"
                alt="R. Dale Brunet"
                className="w-14 h-14 rounded-full object-cover"
                data-testid="footer-logo"
              />
              <h3 className="text-3xl md:text-4xl font-bold text-white">
                R. Dale Brunet
              </h3>
            </div>
            <p className="text-muted-foreground text-lg leading-relaxed max-w-md mb-6">
              Technology Architect, AI Strategist, Entrepreneur, and Author building at the intersection of innovation and human potential.
            </p>
            <div className="flex items-center gap-2 text-muted-foreground">
              <MapPin size={18} className="text-primary" />
              <span>Colorado Springs, Colorado</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-widest mb-6">Navigation</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/about" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-about">About</Link>
              <Link to="/ventures" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-ventures">Ventures</Link>
              <Link to="/books" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-books">Books</Link>
              <Link to="/insights" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-insights">Insights</Link>
              <Link to="/speaking" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-speaking">Speaking</Link>
              <Link to="/schedule" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-services">Services</Link>
              <Link to="/chefbb" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-chefbb">Chef BB</Link>
              <Link to="/hca" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-hca">Human Continuity Architecture</Link>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-widest mb-6">Connect</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/schedule" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-schedule">Schedule a Conversation</Link>
              <Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-contact">Contact</Link>
              <a href="https://www.linkedin.com/in/robert-brunet-959713320" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-2">
                <Linkedin size={16} />
                LinkedIn
              </a>
              <a href="mailto:robert@rdbrunet.com" className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-2">
                <Mail size={16} />
                Email
              </a>
              <a href="https://substack.com/@youraiwhisperer" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-2" data-testid="footer-substack">
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z"/></svg>
                Substack
              </a>
            </nav>
          </div>
        </div>

        <div className="border-t border-border/30 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm">
            Copyright &copy; {currentYear} Use What You Got Publishing, LLC - <a href="https://www.uwygpublishing.com" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">www.UWYGPublishing.com</a>
          </p>
          <p className="text-muted-foreground text-sm">
            Also known as Robert Brunet / Chef BB
          </p>
        </div>
      </div>
    </footer>
  );
};
